import classNames from 'classnames';

import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const Loading = ({ className = '' }) => {
  const isTempo = useBrand(TEMPO);

  return (
    <div data-testid="loading" className={classNames('my-8 text-center', className)}>
      <i
        className={classNames(
          'inline-block h-16 w-16 animate-spin rounded-[50%] border-2 border-solid border-transparent align-middle',
          {
            'border-t-tempo-navy-100': isTempo,
            'border-t-green-100': !isTempo,
          }
        )}
      >
        <span className="sr-only">Loading...</span>
      </i>
    </div>
  );
};

Loading.propTypes = {
  className: PropTypes.string,
};

export default Loading;
